/*
 * @Author: ljiangyun 396242451@qq.com
 * @Date: 2024-03-23 17:04:32
 * @LastEditors: ljiangyun 396242451@qq.com
 * @LastEditTime: 2024-07-01 16:35:19
 * @FilePath: /光明风控平台_PC端/src/lib/img.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  center: require("../assets/images/center.gif"),
  normal_bg: require("../assets/images/normal_bg.png"),
  normal_title: require("../assets/images/normal_title.png"),
  sensitive_bg: require("../assets/images/sensitive_bg.png"),
  sensitive_title: require("../assets/images/sensitive_title.png"),
  background_bg: require("../assets/images/background.png"),
  img1: require("../assets/images/img1.png"),
  img4: require("../assets/images/img4.png"),
  angle: require("../assets/images/angle.png"),
  logo: require("../assets/images/logo.png"),
  logoword: require("../assets/images/logoword.png"),
  change: require("../assets/images/change.png"),
  logory: require("../assets/images/logory_new.jpg"),
  wordry: require("../assets/images/wordry.png"),
};
